import { get, post, put, Delete } from "../axios";

// 盘厂列表-列表
export const factoryManageList = (params) =>
  get("/web/factory/manage/list", params);

// 盘厂列表-新增
export const factoryManageAdd = (params) =>
  post("/web/factory/manage/add", params);

// 盘厂列表-编辑
export const factoryManageUpdate = (params) =>
  put("/web/factory/manage/update", params);

// 盘厂列表-删除
export const factoryManageDelete = (id) =>
  Delete("/web/factory/manage/delete/" + id, "");

// 盘厂列表-权益列表（用于新增和编辑）
export const factoryManageEquityClassifyList = (params) =>
  get("/web/factory/manage/equity/classify/list", params);

// 盘厂列表-同步三方信用代码数据
export const factoryManageSyncCreditCode = (params) =>
  get("/web/factory/manage/sync/credit-code", params);

// 盘厂列表-详情
export const factoryManageDetail = (id) =>
  get("/web/factory/manage/view/" + id, "");

// 盘厂列表-首页推荐-状态编辑
export const factoryManageHomeUpdate = (params) =>
  put("/web/factory/manage/home/update", params);
// 盘厂列表-参数显示详情
export const factoryManageParamView = () =>
  get("/web/factory/manage/param/view", "");
// 盘厂列表-参数显示-修改
export const factoryManageParamUpdate = (params) =>
  put("/web/factory/manage/param/update", params);

// 盘厂业绩-列表
export const factoryPerformanceList = (params) =>
  get("/web/factory/manage/performance/list", params);

// 盘厂业绩-新增
export const factoryPerformanceAdd = (params) =>
  post("/web/factory/manage/performance/add", params);

// 盘厂业绩-编辑
export const factoryPerformanceUpdate = (params) =>
  put("/web/factory/manage/performance/update", params);

// 盘厂业绩-删除
export const factoryPerformanceDelete = (id) =>
  Delete("/web/factory/manage/performance/delete/" + id, "");

// 盘厂业绩-统计
export const factoryPerformanceTotal = (params) =>
  get("/web/factory/manage/performance/total", params);

// 盘厂合同-列表
export const factoryContractList = (params) =>
  get("/web/factory/manage/contract/list", params);

// 盘厂合同-新增
export const factoryContractAdd = (params) =>
  post("/web/factory/manage/contract/add", params);

// 盘厂合同-编辑
export const factoryContractUpdate = (params) =>
  put("/web/factory/manage/contract/update", params);

// 盘厂合同-删除
export const factoryContractDelete = (id) =>
  Delete("/web/factory/manage/contract/delete/" + id, "");

// 盘厂合同-详情
export const factoryContractView = (id) =>
  get("/web/factory/manage/contract/view/" + id, "");

// 盘厂列表-根据统一社会信用代码或盘厂全称查询三方信息
export const factoryManageInfoQuery = (params) =>
  get("/web/factory/credit/code/query", params);
